<template>
  <div
    v-bind:style="showModalMap ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Ubicación</h5>
          <button @click="close(false)" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <GmapMap
            :center="{lat, lng}"
            :zoom="12"
            style="width: 100%; height: 400px;">

            <GmapMarker
              :position="{lat, lng}"
              :clickable="true"
              :draggable="false">
            </GmapMarker>

          </GmapMap>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modalMap',
  props: ['showModalMap', 'lat', 'lng'],
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

